import { render, staticRenderFns } from "./RealChildStation.vue?vue&type=template&id=4673b8b5"
import script from "./RealChildStation.vue?vue&type=script&lang=js"
export * from "./RealChildStation.vue?vue&type=script&lang=js"
import style0 from "./RealChildStation.vue?vue&type=style&index=0&id=4673b8b5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports